export default __webpack_public_path__ + "static/media/thought_baloon.a9ae498f.svg";